var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaution(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 36,
    viewBox: "0 0 41 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.12432 15.5241C12.9602 5.17436 15.8781 0.000488281 20.5 0.000488281C25.1199 0.000488281 28.0398 5.17436 33.8757 15.5241L34.6037 16.8121C39.4535 25.4119 41.8795 29.7118 39.6875 32.8557C37.4956 35.9996 32.0717 35.9996 21.228 35.9996H19.772C8.92828 35.9996 3.50441 35.9996 1.31246 32.8557C-0.879486 29.7118 1.54646 25.4119 6.39634 16.8121L7.12432 15.5221V15.5241ZM20.5 8.50028C20.8978 8.50028 21.2793 8.65831 21.5606 8.93961C21.8419 9.22091 22 9.60243 22 10.0002V20C22 20.3978 21.8419 20.7793 21.5606 21.0606C21.2793 21.3419 20.8978 21.5 20.5 21.5C20.1022 21.5 19.7207 21.3419 19.4394 21.0606C19.1581 20.7793 19 20.3978 19 20V10.0002C19 9.60243 19.1581 9.22091 19.4394 8.93961C19.7207 8.65831 20.1022 8.50028 20.5 8.50028ZM20.5 27.9998C21.0304 27.9998 21.5391 27.7891 21.9142 27.414C22.2892 27.039 22.5 26.5303 22.5 25.9999C22.5 25.4694 22.2892 24.9607 21.9142 24.5857C21.5391 24.2106 21.0304 23.9999 20.5 23.9999C19.9696 23.9999 19.4609 24.2106 19.0858 24.5857C18.7108 24.9607 18.5 25.4694 18.5 25.9999C18.5 26.5303 18.7108 27.039 19.0858 27.414C19.4609 27.7891 19.9696 27.9998 20.5 27.9998Z",
    fill: "#F23D3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaution);
export default __webpack_public_path__ + "static/media/caution.36249c5b059b0d7b3afe089f7b8863ca.svg";
export { ForwardRef as ReactComponent };